import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayRightFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.97873 7.4605C9.98464 7.46443 9.99056 7.46838 9.9965 7.47234L15.2066 10.9432C15.3574 11.0436 15.4972 11.1367 15.6045 11.2232C15.7166 11.3135 15.8486 11.4387 15.9246 11.6219C16.0251 11.864 16.0251 12.136 15.9246 12.3781C15.8486 12.5613 15.7166 12.6865 15.6045 12.7768C15.4972 12.8633 15.3574 12.9564 15.2067 13.0568L9.97875 16.5395C9.79448 16.6623 9.62878 16.7727 9.48818 16.8488C9.34748 16.925 9.15436 17.0121 8.92895 16.9986C8.64063 16.9814 8.37428 16.839 8.20003 16.6088C8.06379 16.4288 8.02917 16.22 8.01456 16.0607C7.99997 15.9016 7.99999 15.7026 8 15.4813L8 8.54005C8 8.53291 8 8.5258 8 8.5187C7.99999 8.2974 7.99997 8.0984 8.01456 7.93927C8.02917 7.78003 8.06379 7.57116 8.20003 7.39121C8.37428 7.16103 8.64063 7.01859 8.92895 7.00138C9.15436 6.98794 9.34748 7.075 9.48818 7.1512C9.62878 7.22734 9.79447 7.33773 9.97873 7.4605Z",
		fill: "currentColor"
	})
});
export default SvgPlayRightFilled;
